import { useQueryClient } from '@tanstack/react-query';
import { authApi } from '../api/auth';
import { useAuth } from '../hooks/useAuth';
import { showToast } from './Toast';

export default function ImpersonationBanner() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  if (!user?.impersonator) return null;

  async function stop() {
    try {
      await authApi.stopImpersonating();
      queryClient.clear();
      window.location.assign('/');
    } catch (err) {
      showToast(`Stop-impersonate failed: ${(err as Error).message}`, { variant: 'error' });
    }
  }

  const target = user!;
  return (
    <div className="impersonation-banner" role="alert">
      <span className="impersonation-banner-icon" aria-hidden="true">
        ⚠
      </span>
      <span className="impersonation-banner-text">
        Viewing as <strong>{target.name ?? target.email}</strong>{' '}
        <span className={`ds-role ${target.role}`}>{target.role}</span> · started by{' '}
        <strong>{target.impersonator!.name ?? target.impersonator!.email}</strong>
      </span>
      <button type="button" className="impersonation-banner-stop" onClick={stop}>
        Stop impersonating
      </button>
    </div>
  );
}
